import React, { useEffect, useState, Fragment, useContext, useRef } from 'react';
import axios from 'axios';
import { LoginContext } from '../../hooks/context/LoginContext';
import $ from 'jquery';
import jQuery from 'jquery';
import DataTable from 'datatables.net';
import Spinner from 'react-bootstrap/Spinner'
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import swal from 'sweetalert';
import { alertService } from '../../services/alertservice';
import DatePicker from 'rsuite/DatePicker';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';

import { SRLWrapper } from 'simple-react-lightbox';

import { getApiUrl, getPantDocFromNivel, getDecodedCookie, importExcel, getDatePickerDaysName, getAhoraInputDateTimeLocal, MiReplaceAll } from '../../helpers/helperApp';

// CSS
// import 'datatables.net-dt/css/jquery.dataTables.css';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
// import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';

// JS
import 'datatables.net';              // DataTables core
import 'datatables.net-dt';           // DataTables base para estilo DT
import 'datatables.net-bs4';          // Integración con Bootstrap 4
import 'datatables.net-buttons';      // Buttons core
import 'datatables.net-buttons-bs4';  // Buttons para Bootstrap 4
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-select';       // Select (debe ir después de DataTables)
import 'datatables.net-rowreorder';
import 'datatables.net-rowgroup';
import 'datatables.net-responsive';   // Responsive core

// require('datatables.net-dt');
// require('datatables.net-responsive');
// require('datatables.net-buttons');
// require('datatables.net-bs4');

// require('datatables.net/js/jquery.dataTables');
// require('datatables.net-buttons/js/dataTables.buttons');
// require('datatables.net-buttons/js/buttons.colVis');
// require('datatables.net-buttons/js/buttons.flash');
// require('datatables.net-buttons/js/buttons.html5');
// require('datatables.net-buttons/js/buttons.print');
// require('datatables.net-select');

// $.DataTable = DataTable;

let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy = (h < 10 ? h = '0'+h : h = h )+'/'+(mesHoy < 10 ? mesHoy = '0'+mesHoy : mesHoy = mesHoy )+'/'+date.getFullYear();
let lastHorLeidas = null;

var botones = [
    // {
    //     extend: 'pageLength',
    //     text: `<i style='font-size: 20px;' class='fal fa-list-ol'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    //     // titleAttr: 'Ver número de registros'
    // },
    // {
    //     extend: 'copy',
    //     text: `<i style='font-size: 20px;' class='fal fa-copy'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    //     // titleAttr: 'Copiar al portapapeles',
    //     exportOptions: {
    //         columns: ':visible'
    //     }
    // }, 
    // {
    //     extend: 'csv',
    //     filename: hoy,
    //     text: `<i style='font-size: 20px;' class='fal fa-file-csv'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    //     title: hoy,
    //     // titleAttr: 'Exportar a csv',
    //     exportOptions: {
    //         columns: ':visible'
    //     }

    // },    
    {
        extend: 'pdf',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        orientation: 'landscape', 
        title: hoy,
        // titleAttr: 'Exportar a pdf',
        exportOptions: {
            columns: ':visible'
        }
    },
    {
        extend: 'excel',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        title: hoy,
        // titleAttr: 'Exportar a excel',
        exportOptions: {
            columns: ':visible'
        }
    }, 
    // {
    //     extend: 'print',
    //     filename: hoy,
    //     text: `<i style='font-size: 20px;' class='fal fa-print'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    //     title: hoy,
    //     // titleAttr: 'Imprimir',
    //     customize: function ( win ) {
    //         $(win.document.body)
    //             .css( 'font-size', '22pt' );

    //         $(win.document.body).find( 'table' )
    //             .addClass( 'compact' )
    //             .css( 'font-size', '14pt' );
    //     },
    //     exportOptions: {
    //         modifier: {
    //             selected: null
    //         }
    //     },
    //     exportOptions: {
    //         columns: ':visible'
    //     }
    // },
    // {
    //     extend: 'colvis',
    //     text: `<i style='font-size: 20px;' class='fad fa-line-columns'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    // }
];

function MiDataTableDiaHor(props){


    const cookies = new Cookies();

    const { apiKey, confApp } = useContext(LoginContext);

    const loginState = useContext(LoginContext);
    
    
    // ***** props *****
    const { id, data, saveData, columnas, formulario, confPantalla } = props;
    let { buttons, ordering, order, searching, paging, select, saveLoadingTable, loadingTable, columnactions, traduction, linkColumns, functionClickTd, pagelength, columnsFunctionClickTd,  importexcel, verLecturas, saveShowErrorLeidas } = props;
        
    const tableRef = useRef(null);
    const fileInputRef = useRef(null);
    const dataRef = useRef(props.data);
    
    useEffect(() => {
        dataRef.current = props.data;
    }, [props.data]);

    
    useEffect(()=>{       

        const accionesMiDataTable = columnas.find(column => column["title"] === columnactions);

        // Si ya existe la columna de acciones la eliminamos ya que sino da error cuando seleccionas un reg, vas a otra pantalla, vuelves y seleccionas otro reg.        
        if( accionesMiDataTable !== undefined ){
            columnas.splice( (columnas.length-1), 1 );
        }

        // Añadimos los enlaces a los td
        if( linkColumns != undefined ){
            for( let i = 0; i < columnas.length; i++ ){
                columnas[i].createdCell = (td, cellData, rowData, row, col) => {

                    if( linkColumns[i] != undefined ){
                        // Aplicamos el estilo a las celdas añadiendo las clases recibidas en el sql en el key 'style'
                        if ('style' in rowData){
                            $(td).addClass(rowData["style"]);
                        }
                        //Creamos los enlaces
                        // Si el enlace es a la pantalla de documentos obtenemos la pantalla que le corresponde según su id
                        if( linkColumns[i].link == "/documentos" ){
                            linkColumns[i].link = getPantDocFromNivel(getDecodedCookie('nivel'));
                        }
                        if( linkColumns[i].data.includes("/") && linkColumns[i].link != "" ){
                            const links = linkColumns[i].data.split("/");
                            $(td).html("<a href='"+window.location.origin+linkColumns[i].link+"/"+rowData[links[0]]+"/"+rowData[links[1]]+"' >"+cellData+"</a>");
                        }else if( linkColumns[i].link != "" ){
                            $(td).html("<a href='"+window.location.origin+linkColumns[i].link+"/"+rowData[linkColumns[i].data]+"' >"+cellData+"</a>");
                        }
                    } 
                    // Si la celda contiene la cadena '/assets/' y rowData hay una key foto asumimos que es una foto
                    if( 'foto' in rowData || 'img' in rowData ){
                        if( cellData ){
                            if( cellData.includes('/assets/')  ){
                                $(td).html("<img src='"+getApiUrl(window.location.origin)+cellData+"' style='width: 100px !important; cursor: pointer;' />");
                            }
                        }else{
                            $(td).html("<span></span>");
                        }
                    }                   
                    if( functionClickTd ){
                        if( columnsFunctionClickTd ){
                            if( columnsFunctionClickTd.includes(col) ){
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }
                        }else{
                            $(td).on('click', function (e) {
                                e.preventDefault();
                                functionClickTd(e, rowData);
                            });
                        }                        
                    }                    
                }
            }
        }else{
            for( let i = 0; i < columnas.length; i++ ){
  
                columnas[i].createdCell = (td, cellData, rowData, row, col) => {

                        // Aplicamos el estilo a las celdas añadiendo las clases recibidas en el sql en el key 'style'
                        if ('style' in rowData){
                            $(td).addClass(rowData["style"]);
                        }
                        // Si la celda contiene la cadena '/assets/' y rowData hay una key foto asumimos que es una foto
                        if( 'foto' in rowData || 'img' in rowData ){
                            if( cellData ){
                                if( cellData.includes('/assets/')  ){

                                    let templateFoto = `
                                    <div>                                   
                                            <div class="containerImgTablePending">
                                                <img class="imgUplmTablePending" src=${getApiUrl(window.location.origin)+cellData} />
                                            </div>                                                                                                                                        
                                    </div>
                                    `;
                                    $(td).html(templateFoto);
                                    // $(td).html("<img src='"+getApiUrl(window.location.origin)+cellData+"' style='width: 100px !important; cursor: pointer' />");
                                }
                            }else{
                                $(td).html("<span></span>");
                            }
                        }
                        if( functionClickTd ){
                            if( columnsFunctionClickTd ){
                                if( columnsFunctionClickTd.includes(col) ){
                                    $(td).on('click', function (e) {
                                        e.preventDefault();
                                        functionClickTd(e, rowData);
                                    });
                                }
                            }else{
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }                        
                        }                    
                }
            }
        }

        buttons === undefined || buttons === true || buttons === "true" ? buttons = 'Bfrtip' : buttons = 'frtip';
        ordering === undefined ? ordering = true : ordering = ordering;
        order === undefined ? order = [[0,"asc"]] : order = order;
        searching === undefined ? searching = true : searching = searching;
        paging === undefined ? paging = true : paging = paging;
        pagelength === undefined ? pagelength = traduction.defaultpagelength : pagelength = pagelength;
        select === undefined ? select = false : select = select;

        if(importexcel != null && importexcel != undefined){
            const btnImportExcel = {                                        
                                        text: `<i style='font-size: 20px;' class='fal fa-download'></i>`,
                                        className: 'btn btn-flat mr-1 btn-outline-secondary',
                                        extend: 'excelHtml5',
                                        exportOptions: {
                                            columns: ':all' // Exportamos todas las columnas, visibles y no visibles
                                            // columns: [0, 1, 3] // exporta solo las columnas 0, 1 y 3
                                        },
                                        action: function () {
                                            // Activa el input de archivo oculto
                                            if (fileInputRef.current) {
                                                fileInputRef.current.click();
                                            }
                                        }
                                    };
            // Verificamos si el botón ya existe en el array
            const existeBtn = botones.some(
                (boton) => boton.text === btnImportExcel.text && boton.className === btnImportExcel.className
            );

            // Si no existe, lo añadimos
            if (!existeBtn) {
                botones.push(btnImportExcel);
            }
        }

        columnas.map((columna, i) => {  
   
            if( i == 1 ){
                // Actuales
                columna.createdCell = (td, cellData, rowData, row, col) => {  
                    
                    const FormattedLabel = ({ value }) => {
                        const numericValue = Number(value);                        
                        if(numericValue == 0){
                            return (
                                <span style={{ textAlign: 'right', display: 'block', width: '100%' }}>
                                    0
                                </span>
                            );  
                        }else{
                            // Formatear el número con separadores de miles
                            const location = getDecodedCookie('idioma') == "es" ? "es-ES" : "en-EN";
                            const formatWithThousandsSeparator = (number, locale = 'es-ES') => {
                                const options = {
                                  style: 'decimal',
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                  useGrouping: true // Esto fuerza el uso de separadores de miles
                                };
                                return new Intl.NumberFormat(location, options).format(numericValue);
                              };                        
                            const formattedValue = formatWithThousandsSeparator(value);
                            
                            return (
                                <span style={{ textAlign: 'right', display: 'block', width: '100%' }}>
                                    {formattedValue}
                                </span>
                            );
                        }
                    };

                    let templateNecesario =  ReactDOM.render(
                        <LoginContext.Provider value={loginState}>
                            <div className="row pt-2">
                                <div className="col-12" >
                                    <div className='form-group' style={{marginBottom: "8px"}}>
                                        <FormattedLabel value={rowData.actuales} />                                                                     
                                    </div>                           
                                </div>                            
                            </div>
                        </LoginContext.Provider> 
                    ,td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario);
                } 
            }
            if( i == 2 ){
                // Leidas
                columna.createdCell = (td, cellData, rowData, row, col) => {                           
                    let templateNecesario =  ReactDOM.render(
                        <LoginContext.Provider value={loginState}>
                            <div className='row pt-2'>
                                <div className='col-12'>
                                    <div className='form-group' style={{marginBottom: "8px"}}>
                                        <input  
                                            type={ "number" } 
                                            className={ "form-control text-right"} 
                                            id={ rowData.idequ+"_hleidas" }                                            
                                            defaultValue={ rowData.leidas }                                              
                                            onBlur={ e => handleChangeLeidas(e, rowData) }
                                        />                                                                          
                                    </div>                                
                                </div>
                            </div>                           
                        </LoginContext.Provider> 
                    ,td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario);                                         
                }

            }
            if( i == 3 ){
                // FH lectura
                columna.createdCell = (td, cellData, rowData, row, col) => {                              
                    let templateNecesario =  ReactDOM.render(
                        <LoginContext.Provider value={loginState}>
                            <div className='row pt-2'>
                                <div className='col-12'>
                                    <div className='form-group' style={{marginBottom: "8px"}}>
                                        <DatePicker
                                            id={rowData.idequ+"_fhlectura"}
                                            name={rowData.idequ}
                                            placeholder={' '}
                                            format={"yyyy-MM-dd HH:mm"}
                                            defaultValue={ rowData.fhlectura == '' ? new Date(getAhoraInputDateTimeLocal()) : new Date(rowData.fhlectura) }
                                            onOk={(value, event) => handleChangeFHLecturas(value, rowData)}                                
                                            readOnly={ ""}
                                            className={''}
                                            disabled={ false } 
                                            // showTime
                                            block={true}
                                            weekStart={1}
                                            locale={getDatePickerDaysName()}
                                            placement={'auto'}
                                        />                                                                        
                                    </div>                                
                                </div>
                            </div>                           
                        </LoginContext.Provider> 
                    ,td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario);                                         
                }

            }                   
            if( i == 4 ){
                // Acciones
                const nivelUsu = getDecodedCookie('nivel');
                if(nivelUsu <= 2){
                    columna.createdCell = (td, cellData, rowData, row, col) => {  
                        let templateNecesario =  ReactDOM.render(
                            <div className="flex-center">                           
                                <span 
                                    id={ rowData.id } 
                                    className="btn btn-outline-primary deleteRow mr-1" 
                                    // style={{border: 0}}
                                    onClick={ e => { handleVer(e, rowData) } }>
                                        <i  
                                                id={ rowData.id }
                                                className="fal fa-history"
                                                onClick={ e => { handleVer(e, rowData) }}
                                            >
                                        </i>
                                </span>                            
                            </div>
                        ,td);
                        $(td).addClass(rowData.style);
                        $(td).html(templateNecesario)
                    } 
                }
            }
        })


        let auxColumnDefs =  [            
            { "type": "html-input", "targets": 1 },
            { "type": "html-input", "targets": 2 },
        ];
        

        if( data ){
            if( data.length > 0 ){
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable = $("."+id).DataTable();
                    oTable.clear( );
                    for (let i = 0; i < data.length; i++){
                        oTable.row.add(data[i]);      
                    }
                    oTable.draw();               
                }else{
                    $("."+id).DataTable({
                        mark: true,
                        rowId: function(a) {
                            return '#row-' + a.idequ;},
                        columnDefs: auxColumnDefs,
                        dom: buttons,
                        data: data,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.sprocessing.title,
                            "sLengthMenu":    traduction.slengthmenu.title,
                            "sZeroRecords":   traduction.szerorecords.title,
                            "sEmptyTable":    traduction.semptytable.title,
                            "sInfo":          traduction.sinfo.title,
                            "sInfoEmpty":     traduction.sinfoempty.title,
                            "sInfoFiltered":  traduction.sinfofiltered.title,
                            "sInfoPostFix":   traduction.sinfopostfix.title,
                            "sSearch":        traduction.ssearch.title,
                            "sUrl":           traduction.surl.title,
                            "sInfoThousands":  traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst":    traduction.sfirst.title,
                                "sLast":    traduction.slast.title,
                                "sNext":    traduction.snext.title,
                                "sPrevious": traduction.sprevious.title
                            },
                            "oAria": {
                                "sSortAscending":  traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }        
                        },
                        // rowCallback : function (row, data, index){ 
                        //     // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                        //     for (let item of row.children) {
                        //         if( item.outerText.includes("#") ){
                        //             item.bgColor = item.outerText;
                        //             item.innerText = "";
                        //         }
                        //     }
                        // }
                    })
                }  
                // saveLoadingTable(false);       
            }else{
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable = $("."+id).DataTable();
                    oTable.clear();
                    oTable.draw();               
                }{               
                    $("."+id).DataTable({
                        mark: true,
                        rowId: function(a) {
                            return '#row-' + a.idequ;},
                        columnDefs: auxColumnDefs,
                        dom: buttons,
                        data: null,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.sprocessing.title,
                            "sLengthMenu":    traduction.slengthmenu.title,
                            "sZeroRecords":   traduction.szerorecords.title,
                            "sEmptyTable":    traduction.semptytable.title,
                            "sInfo":          traduction.sinfo.title,
                            "sInfoEmpty":     traduction.sinfoempty.title,
                            "sInfoFiltered":  traduction.sinfofiltered.title,
                            "sInfoPostFix":   traduction.sinfopostfix.title,
                            "sSearch":        traduction.ssearch.title,
                            "sUrl":           traduction.surl.title,
                            "sInfoThousands":  traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst":    traduction.sfirst.title,
                                "sLast":    traduction.slast.title,
                                "sNext":    traduction.snext.title,
                                "sPrevious": traduction.sprevious.title
                            },
                            "oAria": {
                                "sSortAscending":  traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }         
                        },
                        // rowCallback : function (row, data, index){
                        //     // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                        //     for (let item of row.children) {
                        //         if( item.outerText.includes("#") ){
                        //             item.bgColor = item.outerText;
                        //             item.innerText = "";
                        //         }
                        //     }
                        // }
                    })
                }
                // saveLoadingTable(false);
            }
        }else{
            if ( $.fn.DataTable.isDataTable("."+id) ) {
                let oTable = $("."+id).DataTable();
                oTable.clear();
                oTable.draw();               
            }{               
                $("."+id).DataTable({
                    mark: true,
                    rowId: function(a) {
                        return '#row-' + a.idequ;},
                    columnDefs: auxColumnDefs,
                    dom: buttons,
                    data: null,
                    columns: columnas,
                    ordering: ordering,
                    order: order,
                    searching: searching,
                    paging: paging,
                    select: select,
                    buttons: [botones],
                    // fixedHeader: true,
                    // scrollX: true,
                    responsive: false, 
                    autoWidth: false,
                    retrieve: true,
                    pageLength: parseInt(pagelength),
                    lengthMenu: [
                        [ 10, 25, 50, 100 ],
                        [ '10', '25', '50', '100' ]
                    ],
                    deferRender: true,
                    language: {
                        "sProcessing":    traduction.sprocessing.title,
                        "sLengthMenu":    traduction.slengthmenu.title,
                        "sZeroRecords":   traduction.szerorecords.title,
                        "sEmptyTable":    traduction.semptytable.title,
                        "sInfo":          traduction.sinfo.title,
                        "sInfoEmpty":     traduction.sinfoempty.title,
                        "sInfoFiltered":  traduction.sinfofiltered.title,
                        "sInfoPostFix":   traduction.sinfopostfix.title,
                        "sSearch":        traduction.ssearch.title,
                        "sUrl":           traduction.surl.title,
                        "sInfoThousands":  traduction.sinfothousands.title,
                        "sLoadingRecords": traduction.sloadingrecords.title,
                        "oPaginate": {
                            "sFirst":    traduction.sfirst.title,
                            "sLast":    traduction.slast.title,
                            "sNext":    traduction.snext.title,
                            "sPrevious": traduction.sprevious.title
                        },
                        "oAria": {
                            "sSortAscending":  traduction.ssortascending.title,
                            "sSortDescending": traduction.ssortdescending.title
                        },
                        select: {
                            rows: traduction.rows.title
                        },
                        buttons: {
                            copyTitle: traduction.copytitle.title,
                            copyKeys: traduction.copykeys.title,
                            copySuccess: {
                                _: traduction.copysuccess.many.title,
                                1: traduction.copysuccess.one.title
                            },
                        }       
                    },
                    // rowCallback : function (row, data, index){
                    //     // Si algún td incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                    //     for (let item of row.children) {
                    //         if( item.outerText.includes("#") ){
                    //             item.bgColor = item.outerText;
                    //             item.innerText = "";
                    //         }
                    //     }                        
                    // }
                })
            }
            // saveLoadingTable(false);
            
        }
        
        if( saveLoadingTable ){
            saveLoadingTable(false); 
        }
        
    }, [data, formulario.id])

    const handleFileChange = (e) => {       
        
        importExcel(e, data, saveData, traduction, 'diahor/midatatablediahor');
        
    };
    

    const handleChangeLeidas = async (e, rowData) => {       
        
        if(rowData.leidas != e.target.value){           

            let spinner = document.getElementById(`spinTableLarge`);
            if(spinner) spinner.classList.remove('noDisplay');       
    
            const fhLecturas = document.getElementById(rowData.idequ+"_fhlectura").value;               
            const dataForm = new FormData();      
            dataForm.append("validacion", apiKey());
            dataForm.append("row", JSON.stringify(rowData));
            dataForm.append("hleidas", e.target.value);        
            dataForm.append("fhlecturas", MiReplaceAll(fhLecturas, " ", "T")); 
            const respuesta = await axios.post(getApiUrl(window.location.origin)+"/diahor/actions",dataForm);
    
            if(typeof respuesta.data == "string"){
                // Error
                let tr = document.getElementById(`#row-${rowData.idequ}`);    
                if( tr ){                
                    tr.children[2].classList.add('alert-danger');                
                }
            }else{                         
                const auxData = dataRef.current.map((row) => {                
                    if(row.idequ == rowData.idequ){                    
                        row.idlineanew = respuesta.data; 
                        row.leidas = e.target.value;
                    }
                    return row;
                });             
                saveData(auxData);
    
                let tr = document.getElementById(`#row-${rowData.idequ}`); 
                if( tr ){                
                    tr.children[2].classList.add('alert-success');                
                }
                
                if(lastHorLeidas != null){
                    if(e.target.value < lastHorLeidas){
                        // saveShowErrorLeidas(true);
                        alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.diahor.controles.txterrorleidas.title}`, {autoClose: true}); 
                    }else{
                        // Si las horas que metemos son mayores a las actuales almacenamos las nuevas horas en el row y las mostramos en la tabla modificando el span
                        rowData.actuales = e.target.value;              
                        var spanActuales = document.querySelector(`#\\#row-${rowData.idequ} > td:nth-child(2) > div > div > div > span`);
                        spanActuales.textContent = e.target.value;
                    }
                }else {
                    if(e.target.value < rowData.actuales){
                        // saveShowErrorLeidas(true);
                        alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.diahor.controles.txterrorleidas.title}`, {autoClose: true}); 
                    }else{
                        // Si las horas que metemos son mayores a las actuales almacenamos las nuevas horas en el row y las mostramos en la tabla modificando el span
                        rowData.actuales = e.target.value;              
                        var spanActuales = document.querySelector(`#\\#row-${rowData.idequ} > td:nth-child(2) > div > div > div > span`);
                        spanActuales.textContent = e.target.value;
                    }
                }
                lastHorLeidas = e.target.value;
                
            }        
    
            if(spinner) spinner.classList.add('noDisplay');
        }
       
    }   

    const handleChangeFHLecturas = async (e, rowData) => { 

        // saveShowErrorLeidas(false);

        let spinner = document.getElementById(`spinTableLarge`);
        if(spinner) spinner.classList.remove('noDisplay');

        const anho = e.getFullYear()
        const mes = e.getMonth()+1 < 10 ? '0'+(e.getMonth()+1) : e.getMonth()+1;
        const dia = e.getDate() < 10 ? '0'+e.getDate() : e.getDate();
        const horas = e.getHours() < 10 ? '0' + e.getHours() : e.getHours(); 
        const minutos = e.getMinutes() < 10 ? '0' + e.getMinutes() : e.getMinutes();
        const fecha = `${anho}-${mes}-${dia}T${horas}:${minutos}`;        
        const dataForm = new FormData();        
        const hLeidas = document.getElementById(rowData.idequ+"_hleidas").value;            
        dataForm.append("validacion", apiKey());        
        dataForm.append("row", JSON.stringify(rowData));
        dataForm.append("fhlecturas", fecha); 
        dataForm.append("hleidas", hLeidas);           
        const respuesta = await axios.post(getApiUrl(window.location.origin)+"/diahor/actions",dataForm);        

        if(typeof respuesta.data == "string"){
            // Error
            let tr = document.getElementById(`#row-${rowData.idequ}`); 
            if( tr ){                
                tr.children[3].classList.add('alert-danger');                
            }
        }else{            
            const auxData = dataRef.current.map((row) => {                
                if(row.idequ == rowData.idequ){                                   
                    row.idlineanew = respuesta.data; 
                    row.fhlectura = MiReplaceAll(fecha, "T", " ");
                }
                return row;
            });                        
            saveData(auxData);

            let tr = document.getElementById(`#row-${rowData.idequ}`);    
            if( tr ){                
                tr.children[3].classList.add('alert-success');                
            }          
           
        }
       
        if(spinner) spinner.classList.add('noDisplay');
       
    }   
     
    const handleVer = (e, rowData) => {
        e.stopPropagation();
        verLecturas(e, rowData);
    }

    // Busqueda en los input, select de la tabla
    $.fn.dataTableExt.ofnSearch['html-input'] = function(value) {        
        if(/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)$/.test(value) || /^(\d{4})-(\d\d)-(\d\d)$/.test(value) ){            
            // return dateSqlToLocal(value+"T00:00", getDecodedCookie('idioma'));
            return value;
        }else{                           
            return value;
        }   
    };


    // Código para evitar los acentos en las búsquedas
    function removeAccents ( data ) {
        if ( data.normalize ) {
            // Use I18n API if avaiable to split characters and accents, then remove
            // the accents wholesale. Note that we use the original data as well as
            // the new to allow for searching of either form.
            return data +' '+ data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }
     
        return data;
    }
    var searchType = jQuery.fn.DataTable.ext.type.search;
 
    searchType.string = function ( data ) {
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data ) :
                data;
    };
    
    searchType.html = function ( data ) {
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data.replace( /<.*?>/g, '' ) ) :
                data;
    };
    // FIN: Código para evitar los acentos en las búsquedas





    return(
        <Fragment>
            {   loadingTable ? 
                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                        <Spinner animation="border" />
                    </div>
                :
                null
            }
            <div style={{overflowX: "auto"}}>
                <div id="spinTableLarge" className="noDisplay" style={{ textAlign: "center"}} >
                    {/* <Spinner animation="border" /> */}
                    <SpinnerFloat  />
                </div>                          
                <table id={id} className={id+" table table-sm table-bordered table-striped table-hover dataTable"} style={{width:"99%"}} ></table>
                {/* Input de archivo oculto para la importación de Excel */}
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".xls,.xlsx"
                    onChange={handleFileChange}
                />
            </div>   
            
        </Fragment>
    )
}

export default MiDataTableDiaHor;